import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import paulChapman from "../../images/paulChapman.jpeg";
import './style.css';
import CtaBtn from "../UIElements/CtaBtn";
import Icon from "../UIElements/Icons";
// import TickerCarousel from "./TickerCarousel";
import Ticker from 'framer-motion-ticker';

function AwardsRecognition({nobg, customQuote}) {

    const data = useStaticQuery(graphql`
        query AwardsQuery {
            allStrapiAward(sort: {Date: DESC}, limit: 7) {
                edges {
                node {
                    AwardingOrganisation
                    Link
                    Logo {
                        url
                    }
                    Name
                    ScopeRegion
                    id
                }
                }
            }
            }
         `)

    
    return (
        <div>
            <div className={`${!nobg ? 'bg-global-500' : ''} px-10 py-20 lg:p-20`}>
                <div className="w-[320px] h-[320px] lg:w-[800px] lg:h-[800px] absolute rounded-full border-[1.5px] border-blue-700/25 -left-56 -mt-44 z-0"></div>
                <div className={`${nobg ? 'hidden' : ''} relative flex flex-1 justify-end`} >
                    <div className="absolute right-56  -top-36">
                        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                            <circle cx="60" cy="60" r="60" fill="white"/>
                        </svg>
                    </div>
                    <div className="absolute right-40 -top-10">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#60B7ED"/>
                        </svg>
                    </div>
                    <div className="absolute right-48 -top-8">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <circle opacity="0.25" cx="20" cy="20" r="20" fill="#60B7ED"/>
                        </svg>
                    </div>                     
                </div>
                <div className="">
                    <div className="max-w-full lg:max-w-7xl mx-auto">
                        {/* <div className="text-blue-700 font-title font-semibold text-4xl">
                            Awards & Recognition
                        </div> */}
                        <div className="block lg:flex mt-10 lg:mx-10">
                            <div className="min-w-[230px]">
                                <img src={customQuote?.image ? customQuote.image : paulChapman} className="bg-white rounded-full h-[160px] w-[160px] lg:h-[200px] lg:w-[200px] object-scale-down relative z-10 float-right lg:float-none" />
                                <div className="relative -top-12 lg:-left-4 z-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                                    <circle opacity="0.25" cx="40" cy="40" r="40" fill="#60B7ED"/>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div className="mt-24 lg:mt-0 border-t-[1px] border-b-[1px] py-10 border-blue-700/25 lg:flex">
                                    <div className="float-left lg:float-none -mt-28 lg:mt-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 50" fill="none" className="w-[72px] h-[60px] lg:w-[60px] lg:h-[50px]">
                                            <path opacity="0.25" d="M3.13433 50C1.04478 42.2619 0 34.8958 0 27.9018C0 9.3006 8.35821 0 25.0746 0V11.1607C17.9104 11.1607 14.3284 15.4018 14.3284 23.8839V28.5714L26.194 28.5714L26.194 50H3.13433ZM36.9403 50C34.8507 42.2619 33.806 34.8958 33.806 27.9018C33.806 9.3006 42.2388 0 59.1045 0V11.1607C55.3731 11.1607 52.6119 12.2024 50.8209 14.2857C49.0299 16.369 48.1343 19.5684 48.1343 23.8839V28.5714H60L60 50H36.9403Z" fill="#60B7ED"/>
                                        </svg>
                                    </div>
                                    <div className="">
                                        <div className="px-6 text-blue-700 font-title text-lg font-semibold">
                                            {customQuote?.quote ? customQuote.quote : `Over the past 5 years my team has developed analytical insights which have generated multi 
                                            million dollar savings of which a considerable amount can be attributed to the Data School 
                                            consultants we have had working on projects.`}
                                        </div>
                                        <div className="px-6 mt-4 text-blue-700 font-title text-sm font-semibold">
                                        {customQuote?.name ? customQuote.name : `Paul Chapman, Global Director of Performance Management, BI and Innovation at JLL`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-white w-full p-6 overflow-hidden">
                {/* <TickerCarousel duration={300} className=""> */}
                <Ticker duration={60}>
                        {data?.allStrapiAward?.edges?.map((a) => {
                            const award = a.node;
                            return (
                                <div key={award.id} className={"border-r-[1px] border-blue-700 flex w-[480px] content-center mx-auto align-middle pr-6"}>
                                    <div className="mx-auto flex">
                                        <div className="mx-6 my-auto"><img src={award.Logo.url} className="h-[90px] pointer-events-none" /></div>
                                        <div className="my-auto">
                                            <div className="font-semibold text-blue-700 font-title text-[17px]">{award.AwardingOrganisation}</div>
                                            <div className="font-semibold text-global-500 font-title text-[17px]">{award.Name}</div>
                                            <div className="font-semibold text-blue-700 font-title text-[14px]">{award.ScopeRegion}</div>
                                        </div>
                                    </div>
                                    
                                </div>
                            )
                        })}
                {/* </TickerCarousel> */}
                </Ticker>
            </div>
        </div>
    )
}

function SmallBar() {
    return (
        <div>
            <div className="bg-global-500 h-[60px]">
                <div className="relative flex flex-1 justify-end">
                    <div className="absolute right-40  -top-8 -z-10">
                        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                            <circle cx="30" cy="30" r="30" fill="white"/>
                        </svg>
                    </div>
                    <div className="absolute left-0 -top-20">
                        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="240" viewBox="0 0 120 240" fill="none">
                            <circle cy="120" r="119.25" stroke="#60B7ED" strokeWidth="1.5"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}

function BlogPost({
        label,
        post
    }) {
    return (
        <div>
            <div className="bg-global-500 py-24">
                <div className="relative flex flex-1 justify-end">
                    <div className="md:hidden absolute left-0 -top-72 opacity-25 z-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="400" viewBox="0 0 200 400" fill="none">
                            <circle cy="200" r="200" stroke="#60B7ED" strokeWidth="1"/>
                        </svg>
                    </div>
                    <div className="absolute right-12 md:right-40 -top-[125px] md:-top-40">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-[60px] w-[60px] md:h-[120px] md:w-[120px]" viewBox="0 0 120 120" fill="none">
                            <circle cx="60" cy="60" r="60" fill="white"/>
                        </svg>
                    </div>
                    <div className="hidden md:block absolute left-16 -top-12">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <circle cx="20" cy="20" r="20" fill="#BBE5FF"/>
                        </svg>
                    </div>
                    <div className="hidden md:block absolute left-0 top-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="120" viewBox="0 0 60 120" fill="none">
                            <circle cy="60" r="60" fill="#3797D3"/>
                        </svg>
                    </div>
                    <div className="md:hidden absolute right-10 -top-14">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 10 10" fill="none">
                            <circle cx="5" cy="5" r="5" fill="#3797D3"/>
                        </svg>
                    </div>
                    <div className="absolute left-0 top-[650px] md:top-96">
                        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="240" viewBox="0 0 120 240" fill="none">
                            <circle cy="120" r="119.25" stroke="#60B7ED" strokeWidth="1.5"/>
                        </svg>
                    </div>
                </div>
                <div className="max-full xl:mx-auto xl:max-w-7xl px-2 md:px-10">
                    <div className="font-title text-[25px] md:text-[35px] font-semibold text-blue-700">
                        <div className="max-w-[780px] mx-8 md:mx-[87px]">
                        {label} 
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 max-w-[1000px] ml-[87px] mt-6 md:mt-12">
                        <div className="col-span-1"> 
                            <div
                                style={{ 
                                    borderRadius: 280,
                                    background: `${post.FeatureImageUrl || post.FeatureImage?.url ? `url(${post.FeatureImageUrl || post.FeatureImage?.url}) no-repeat,` : ''} #60B7ED`,
                                    backgroundPosition: '50% 50%',
                                    backgroundSize: 'cover'
                                }}
                                className={`bg-blue-300 flex align-middle h-[280px] w-[280px]`}
                            >
                            </div>
                        </div>
                        <div className="col-span-2 md:px-16 pt-2 pb-8 md:py-8 -ml-16 mt-4 md:mt-0 mr-10 md:mr-0 border-t-[1px] border-b-[1px] border-blue-300/25">
                            <div className="inline-flex align-middle">
                                <Icon type={post.Type || 'blog'} colour={'#BBE5FF'} />
                                <div className="text-blue-100 font-normal text-sm mt-2 ml-3">{post.publishedAt}</div>
                            </div>
                            <div className="font-title font-semibold text-[20px] md:text-[30px] leading-[30px] text-blue-700 my-3">{post.Title}</div>
                            <div className="mb-5 text-[14px] md:text-[15px] leading-[25px] text-blue-500">{post.Excerpt}</div>
                            <div>
                                <CtaBtn label={post.Type === "Video" ? 'Watch Now' : 'Read the article'} colour={'blue'} link={'/community/blog/' + post.Slug} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { AwardsRecognition, SmallBar, BlogPost }